// extracted by mini-css-extract-plugin
export default {"billInfosContainer":"PrivateBillView_billInfosContainer__IVzFu","billDetails":"PrivateBillView_billDetails__f5GIt"};